"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var LoggerAnalytics = /** @class */ (function () {
    function LoggerAnalytics(enabledConsoleLog) {
        this.isConsoleLogEnabled = enabledConsoleLog;
    }
    LoggerAnalytics.prototype.build = function () {
        console.info(constants_1.BUILD_LOGGER_MESSAGE);
    };
    LoggerAnalytics.prototype.pageView = function (path) {
        console.info("%c pageView: %c ".concat(path), "color: blue", "color: green");
    };
    LoggerAnalytics.prototype.event = function (action, category) {
        console.info("%c event: [".concat(category, "] %c ").concat(action), "color: blue", "color: green");
    };
    LoggerAnalytics.prototype.dimensionEvent = function (action, category, label, value) {
        console.info("%c [".concat(category, "] %c ").concat(action, " %c ").concat(label, " %c ").concat(value), "color: blue", "color: green", "color: blue", "color: red");
    };
    LoggerAnalytics.prototype.customEvent = function (name, info) {
        var properties = JSON.stringify(info, null, 2);
        console.info("%c customEvent: [".concat(name, "] %c\n      ").concat(properties), "color: blue", "color: green");
    };
    LoggerAnalytics.prototype.trace = function (message) {
        console.info("%c trace: %c ".concat(message), "color: blue", "color: green");
    };
    LoggerAnalytics.prototype.isEnabled = function () {
        return this.isConsoleLogEnabled;
    };
    LoggerAnalytics.prototype.eventData = function (data) {
        var trackedData = JSON.stringify(data, null, 2);
        console.info("%c data: ".concat(trackedData), "color: green");
    };
    return LoggerAnalytics;
}());
exports.default = LoggerAnalytics;
